import { HDKey } from 'ethereum-cryptography/hdkey';
console.log('wallet-utils module loaded');

async function deriveExtendedKeys(seedHex: string) {
    console.log('deriveExtendedKeys called with seed:', seedHex);
    // Convert hex string back to Uint8Array
    const seed = new Uint8Array(seedHex.match(/.{1,2}/g)!.map(byte => parseInt(byte, 16)));
    console.log('Converted seed to Uint8Array:', seed);
    
    // Create HDKey from seed
    const hdkey = HDKey.fromMasterSeed(seed);
    console.log('Created HDKey');
    
    return {
        xpriv: hdkey.privateExtendedKey,
        xpub: hdkey.publicExtendedKey
    };
}

async function deriveKeyFromPath(xpriv: string, path: string) {
    console.log('deriveKeyFromPath called with path:', path);
    
    try {
        // Create HDKey from xpriv
        const hdkey = HDKey.fromExtendedKey(xpriv);
        console.log('Created HDKey from xpriv');
        
        // Derive child key
        const childKey = hdkey.derive(path);
        console.log('Derived child key');
        
        if (!childKey.privateKey) {
            throw new Error('Failed to derive private key');
        }

        if (!childKey.publicKey) {
            throw new Error('Failed to derive public key');
        }

        // Convert private key to hex string using Uint8Array
        const privateKey = Array.from(childKey.privateKey)
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
        
        // Get the corresponding address (public key hash)
        const address = computeAddress(childKey.publicKey);
        
        return {
            privateKey,
            address
        };
    } catch (error) {
        console.error('Error deriving key:', error);
        throw error;
    }
}

function computeAddress(publicKey: Uint8Array): string {
    // TODO: Implement proper Dogecoin address derivation
    // This should:
    // 1. Hash the public key with SHA256
    // 2. Hash the result with RIPEMD160
    // 3. Add version byte (0x1E for Dogecoin testnet, 0x1E for mainnet)
    // 4. Add checksum
    // 5. Base58 encode
    
    // For now, return a placeholder
    return "DQxnmJxUYqiP8Qm9pLZA3XdQHhpC4Zyyi5";
}

// Expose the functions globally
declare global {
    interface Window {
        deriveExtendedKeys: typeof deriveExtendedKeys;
        deriveKeyFromPath: typeof deriveKeyFromPath;
    }
}

window.deriveExtendedKeys = deriveExtendedKeys;
window.deriveKeyFromPath = deriveKeyFromPath; 